
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/deals-database",
      function () {
        return require("private-next-pages/deals-database.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/deals-database"])
      });
    }
  